@if (indexItems?.length) {
  <div class="relative h-full">
    <!-- Horizontal Index (for mobile and tablet) -->
    <div
      class="top-0 right-0 left-0 z-40 bg-index-background text-alternate-text transition-all duration-300 ease-in-out lg:hidden"
      [ngClass]="{
        fixed: currentScroll() > 0,
        absolute: currentScroll() === 0 && isExpanded(),
      }"
    >
      <div class="flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <h2 class="truncate text-base font-medium text-alternate-text">
          {{ 'components.index.title' | translate }}
        </h2>
        <button
          class="flex items-center space-x-2 text-alternate-text"
          [attr.aria-label]="isExpanded() ? 'Close index' : 'Open index'"
          (click)="toggleIndex()"
        >
          @if (isExpanded()) {
            <span class="text-sm">{{
              'components.index.close' | translate
            }}</span>
          }
          <span
            class="h-6 w-6"
            [innerHTML]="isExpanded() ? closeIcon : menuIcon"
          ></span>
        </button>
      </div>
      <!-- Expanded Content -->
      <div
        class="overflow-y-auto transition-all duration-300"
        [style.maxHeight]="isExpanded() ? '60vh' : '0'"
      >
        <div class="border-t border-neutral-700 bg-index-background px-4 py-3">
          <div class="space-y-2" attr.lang="{{ language() }}">
            @for (item of indexItems; track item) {
              <button
                class="block w-full cursor-pointer py-2 text-left text-base transition-all duration-200 hover:text-neutral-300"
                [ngClass]="{
                  'px-4 font-medium': item.level === 1,
                  'font-normal': item.level > 1,
                  'pl-2': item.level === 2,
                  'pl-4': item.level === 3,
                  'pl-6': item.level === 4,
                  'pl-8': item.level === 5,
                  'pl-10': item.level === 6,
                  'bg-index-active text-orange-400':
                    activeSection() === item.link,
                  'text-alternate-text': activeSection() !== item.link,
                }"
                (click)="onIndexItemClick(item.link)"
                (keydown)="onIndexItemKeydown($event, item.link)"
              >
                {{ item.title }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Vertical Index (for desktop) -->
    <div
      class="fixed z-50 hidden overflow-hidden bg-index-background text-alternate-text transition-all duration-300 ease-in-out lg:block"
      [ngClass]="{ 'w-96': isExpanded(), 'w-16': !isExpanded() }"
      [ngStyle]="{
        height: 'calc(100vh - 5rem)',
        top: '5rem',
        left: '0',
      }"
    >
      <div class="relative flex h-full flex-col">
        <!-- Collapsed state -->
        @if (!isExpanded()) {
          <div class="relative flex h-full flex-col">
            <button
              class="mt-8 ml-5 h-6 w-6 shrink-0 cursor-pointer text-alternate-text transition-colors hover:text-neutral-300"
              [attr.aria-label]="'Open index'"
              (click)="toggleIndex()"
            >
              <span [innerHTML]="menuIcon"></span>
            </button>
            <div
              class="absolute bottom-2 left-3 shrink-0 origin-top-left -rotate-90 text-xl font-normal whitespace-nowrap text-alternate-text"
            >
              {{ 'components.index.title' | translate }}
            </div>
          </div>
        }
        <!-- Expanded content -->
        @if (isExpanded()) {
          <div
            class="absolute inset-0 flex h-full flex-col bg-index-background"
          >
            <!-- Header - Fixed at top -->
            <div class="shrink-0 px-8 pt-8 pb-4">
              <div class="flex justify-end">
                <button
                  class="flex cursor-pointer items-center space-x-2 text-base font-normal text-alternate-text transition-colors hover:text-neutral-300"
                  [attr.aria-label]="'Close index'"
                  (click)="toggleIndex()"
                >
                  <span [innerHTML]="closeIcon"></span>
                  @if (isExpanded()) {
                    <span class="text-sm">{{
                      'components.index.close' | translate
                    }}</span>
                  }
                </button>
              </div>
            </div>
            <!-- Scrollable content -->
            <div class="scrollbar-hide flex-1 overflow-y-auto px-8 pb-8">
              <div class="space-y-2">
                @for (item of indexItems; track item) {
                  <button
                    class="block w-full cursor-pointer py-2 text-left text-base transition-all duration-200 hover:text-neutral-300"
                    [ngClass]="{
                      'px-4 font-medium': item.level === 1,
                      'font-normal': item.level > 1,
                      'pl-2': item.level === 2,
                      'pl-4': item.level === 3,
                      'pl-6': item.level === 4,
                      'pl-8': item.level === 5,
                      'pl-10': item.level === 6,
                      'bg-index-active text-orange-400':
                        activeSection() === item.link,
                      'text-alternate-text': activeSection() !== item.link,
                    }"
                    (click)="onIndexItemClick(item.link)"
                    (keydown)="onIndexItemKeydown($event, item.link)"
                  >
                    {{ item.title }}
                  </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
